// extracted by mini-css-extract-plugin
export var bodySections = "_98-8";
export var gray = "_98-7";
export var green = "_98-4";
export var iconContainer = "_98-9";
export var iconWidgetContainer = "_98-1";
export var phoneIcon = "_98-2";
export var red = "_98-5";
export var statusDot = "_98-3";
export var widgetContainer = "_98-0";
export var yellow = "_98-6";